// GENERATED FILE — do not edit. Source: libs/py-shop-common/shop_common/auth/permissions.py
// Regenerate: uv run --all-packages python scripts/gen_permissions_ts.py  (CI runs --check)
//
// Permission strings follow `<area>.<action>` (design/04 §14). The Python enum is the only place
// they are defined; identity-service issues tokens with these exact values (aliases below are the
// alternate spellings found in older design docs and are resolved server-side).

export const PERMISSIONS = [
  "products.read",
  "products.write",
  "products.publish",
  "catalog.read",
  "catalog.write",
  "collections.read",
  "collections.write",
  "import.run",
  "media.write",
  "media.delete",
  "inventory.read",
  "inventory.receive",
  "inventory.adjust",
  "inventory.transfer",
  "inventory.count",
  "inventory.count.approve",
  "inventory.holds.release",
  "inventory.holds.manage",
  "inventory.conflicts.resolve",
  "inventory.live_show.manage",
  "listings.publish",
  "channels.manage",
  "orders.read",
  "orders.update",
  "orders.fulfill",
  "orders.cancel",
  "orders.refund",
  "orders.edit",
  "discounts.write",
  "payments.read",
  "payments.confirm",
  "payments.refund",
  "payments.reconcile",
  "payments.settings",
  "pos.sell",
  "pos.refund",
  "pos.void",
  "pos.returns",
  "pos.open_drawer",
  "pos.discount_over_10",
  "pos.override_price",
  "pos.shift.manage",
  "pos.devices.pair",
  "pos.hold",
  "pos.manual_line",
  "pos.pay_out",
  "pos.shift_close_variance",
  "pos.reports",
  "buylist.accept",
  "buylist.accept_over_limit",
  "consignment.read",
  "consignment.manage",
  "consignment.intake",
  "consignment.price_override",
  "payouts.create",
  "payouts.export_bank",
  "kyc.verify",
  "kyc.view",
  "kobutsu.read",
  "kobutsu.export",
  "customers.read",
  "customers.write",
  "customers.merge",
  "customers.export",
  "tax.read",
  "tax.taxfree",
  "tax.settings",
  "cms.edit",
  "cms.publish",
  "settings.write",
  "settings.read",
  "staff.read",
  "staff.manage",
  "staff.roles",
  "api_keys.manage",
  "reports.view",
  "reports.consignment",
  "audit.view",
  "audit.export",
  "inbox.read",
  "inbox.manage",
  "notifications.read",
] as const;

export type Permission = (typeof PERMISSIONS)[number];

/** Older/alternate spellings → canonical permission (kept for tokens already issued). */
export const PERMISSION_ALIASES: Readonly<Record<string, Permission>> = {
  "theme.edit": "cms.edit",
  "theme.publish": "cms.publish",
  "content.write": "cms.edit",
  "audit.read": "audit.view",
  "reports.read": "reports.view",
  "staff.write": "staff.manage",
  "consignment.write": "consignment.manage",
  "consignment.payouts.create": "payouts.create",
  "consignment.kobutsu.read": "kobutsu.read",
  "consignment.kobutsu.export": "kobutsu.export",
  "pos.discount": "pos.discount_over_10",
  "media.upload": "media.write",
  api_keys: "api_keys.manage",
};

export const SYSTEM_ROLES = [
  "owner",
  "manager",
  "staff",
  "cashier",
  "content_editor",
  "consignment_manager",
] as const;

export type SystemRole = (typeof SYSTEM_ROLES)[number];

/** Permissions granted to each system role (identity-service seeds the same table). */
export const ROLE_DEFAULTS: Readonly<Record<SystemRole, readonly Permission[]>> = {
  owner: [
    "api_keys.manage",
    "audit.export",
    "audit.view",
    "buylist.accept",
    "buylist.accept_over_limit",
    "catalog.read",
    "catalog.write",
    "channels.manage",
    "cms.edit",
    "cms.publish",
    "collections.read",
    "collections.write",
    "consignment.intake",
    "consignment.manage",
    "consignment.price_override",
    "consignment.read",
    "customers.export",
    "customers.merge",
    "customers.read",
    "customers.write",
    "discounts.write",
    "import.run",
    "inbox.manage",
    "inbox.read",
    "inventory.adjust",
    "inventory.conflicts.resolve",
    "inventory.count",
    "inventory.count.approve",
    "inventory.holds.manage",
    "inventory.holds.release",
    "inventory.live_show.manage",
    "inventory.read",
    "inventory.receive",
    "inventory.transfer",
    "kobutsu.export",
    "kobutsu.read",
    "kyc.verify",
    "kyc.view",
    "listings.publish",
    "media.delete",
    "media.write",
    "notifications.read",
    "orders.cancel",
    "orders.edit",
    "orders.fulfill",
    "orders.read",
    "orders.refund",
    "orders.update",
    "payments.confirm",
    "payments.read",
    "payments.reconcile",
    "payments.refund",
    "payments.settings",
    "payouts.create",
    "payouts.export_bank",
    "pos.devices.pair",
    "pos.discount_over_10",
    "pos.hold",
    "pos.manual_line",
    "pos.open_drawer",
    "pos.override_price",
    "pos.pay_out",
    "pos.refund",
    "pos.reports",
    "pos.returns",
    "pos.sell",
    "pos.shift.manage",
    "pos.shift_close_variance",
    "pos.void",
    "products.publish",
    "products.read",
    "products.write",
    "reports.consignment",
    "reports.view",
    "settings.read",
    "settings.write",
    "staff.manage",
    "staff.read",
    "staff.roles",
    "tax.read",
    "tax.settings",
    "tax.taxfree",
  ],
  manager: [
    "audit.view",
    "buylist.accept",
    "buylist.accept_over_limit",
    "catalog.read",
    "catalog.write",
    "channels.manage",
    "cms.edit",
    "cms.publish",
    "collections.read",
    "collections.write",
    "consignment.intake",
    "consignment.manage",
    "consignment.price_override",
    "consignment.read",
    "customers.merge",
    "customers.read",
    "customers.write",
    "discounts.write",
    "import.run",
    "inbox.manage",
    "inbox.read",
    "inventory.adjust",
    "inventory.conflicts.resolve",
    "inventory.count",
    "inventory.count.approve",
    "inventory.holds.manage",
    "inventory.holds.release",
    "inventory.live_show.manage",
    "inventory.read",
    "inventory.receive",
    "inventory.transfer",
    "kobutsu.export",
    "kobutsu.read",
    "kyc.verify",
    "kyc.view",
    "listings.publish",
    "media.delete",
    "media.write",
    "notifications.read",
    "orders.cancel",
    "orders.edit",
    "orders.fulfill",
    "orders.read",
    "orders.refund",
    "orders.update",
    "payments.confirm",
    "payments.read",
    "payments.reconcile",
    "payments.refund",
    "payouts.create",
    "payouts.export_bank",
    "pos.devices.pair",
    "pos.discount_over_10",
    "pos.hold",
    "pos.manual_line",
    "pos.open_drawer",
    "pos.override_price",
    "pos.pay_out",
    "pos.refund",
    "pos.reports",
    "pos.returns",
    "pos.sell",
    "pos.shift.manage",
    "pos.shift_close_variance",
    "pos.void",
    "products.publish",
    "products.read",
    "products.write",
    "reports.consignment",
    "reports.view",
    "settings.read",
    "staff.read",
    "tax.read",
    "tax.taxfree",
  ],
  staff: [
    "buylist.accept",
    "catalog.read",
    "catalog.write",
    "collections.read",
    "consignment.intake",
    "customers.read",
    "customers.write",
    "inbox.read",
    "inventory.adjust",
    "inventory.count",
    "inventory.holds.manage",
    "inventory.holds.release",
    "inventory.live_show.manage",
    "inventory.read",
    "inventory.receive",
    "inventory.transfer",
    "kyc.verify",
    "media.write",
    "notifications.read",
    "orders.fulfill",
    "orders.read",
    "orders.update",
    "payments.read",
    "pos.hold",
    "pos.manual_line",
    "pos.returns",
    "pos.sell",
    "pos.shift.manage",
    "products.read",
    "products.write",
    "tax.read",
    "tax.taxfree",
  ],
  cashier: [
    "catalog.read",
    "customers.read",
    "inbox.read",
    "inventory.read",
    "kyc.verify",
    "orders.read",
    "pos.hold",
    "pos.sell",
    "products.read",
    "tax.taxfree",
  ],
  content_editor: [
    "catalog.read",
    "cms.edit",
    "collections.read",
    "collections.write",
    "inbox.read",
    "media.write",
    "products.publish",
    "products.read",
  ],
  consignment_manager: [
    "catalog.read",
    "consignment.intake",
    "consignment.manage",
    "consignment.read",
    "customers.read",
    "inbox.read",
    "inventory.read",
    "inventory.receive",
    "kobutsu.read",
    "kyc.verify",
    "media.write",
    "payouts.create",
    "products.read",
    "products.write",
    "reports.consignment",
    "reports.view",
  ],
};

const PERMISSION_SET: ReadonlySet<string> = new Set(PERMISSIONS);

/** Canonical permission for a string (aliases included), or `null` when unknown. */
export function resolvePermission(value: string): Permission | null {
  if (PERMISSION_SET.has(value)) {
    return value as Permission;
  }
  return PERMISSION_ALIASES[value] ?? null;
}

export function isPermission(value: string): value is Permission {
  return PERMISSION_SET.has(value);
}
